function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { classNamesFor } from '../utils/classNames';
import findAndDecorateImageProps from '../utils/findAndDecorateImageProps';
import Icon from '../Icon';
import MediaFrame from '../MediaFrame';
var cx;
var VALID_TROPHY_TYPES = ['bronze', 'silver', 'gold', 'platinum', 'hidden'];
var TROPHY_GRADES = {
  hidden: '',
  platinum: 1,
  gold: 2,
  silver: 3,
  bronze: 4
};

var staticTrophyImageFile = function staticTrophyImageFile(trophyType) {
  return "achievements/trophy-grade".concat(TROPHY_GRADES[trophyType], "-").concat(trophyType, ".png");
};

export var getTrophyTypeImageSrc = function getTrophyTypeImageSrc(trophyType) {
  if (!VALID_TROPHY_TYPES.includes(trophyType)) return null;
  return staticTrophyImageFile(trophyType);
};
/**
 * The Trophy component is a grouping of core metadata related to a
 * trophy. This component can appear alone or often within a list
 *
 * ## Composed of
 * - [Media](../Media/README.md)
 *
 * ## Related Components
 * - [Player](../Player/README.md)
 * - [ChatGroup](../Player/README.md)
 *
 * ## Usage
 *
 * ```jsx
 * <Trophy
 *   title="Some Trophy Title"
 *   description="Some trophy description"
 *   image="https://trophy-images.com/trophy-1.png"
 *   trophyType="gold"
 * />
 *```
 *
 * ## Props
 */

var fallback = /*#__PURE__*/React.createElement(MediaFrame, {
  className: "psw-bg-3",
  aspectRatio: "1:1"
}, /*#__PURE__*/React.createElement(Icon, {
  className: "psw-center",
  type: "trophies"
}));

var Trophy = /*#__PURE__*/function (_PureComponent) {
  _inherits(Trophy, _PureComponent);

  var _super = _createSuper(Trophy);

  function Trophy() {
    _classCallCheck(this, Trophy);

    return _super.apply(this, arguments);
  }

  _createClass(Trophy, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          className = _this$props.className,
          title = _this$props.title,
          description = _this$props.description,
          image = _this$props.image,
          trophyType = _this$props.trophyType;

      var _Trophy$getClassName = Trophy.getClassName({
        className: className
      }),
          root = _Trophy$getClassName.root,
          imageClass = _Trophy$getClassName.image,
          info = _Trophy$getClassName.info,
          titleClass = _Trophy$getClassName.title,
          descriptionClass = _Trophy$getClassName.description;

      var trophyImageSrc = getTrophyTypeImageSrc(trophyType);
      var decoratedImage = findAndDecorateImageProps(image, {
        qa: "".concat(qa, "#image"),
        className: 'psw-fill-x',
        width: '100%',
        children: fallback
      });
      return /*#__PURE__*/React.createElement("article", {
        "data-qa": qa,
        className: root
      }, /*#__PURE__*/React.createElement("div", {
        className: imageClass
      }, decoratedImage || fallback), /*#__PURE__*/React.createElement("div", {
        className: info
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: titleClass
      }, trophyImageSrc && /*#__PURE__*/React.createElement(Icon, {
        qa: "".concat(qa, "#trophyImage"),
        type: "image:".concat(trophyImageSrc),
        label: trophyType
      }), /*#__PURE__*/React.createElement("span", {
        "data-qa": "".concat(qa, "#title")
      }, title))), /*#__PURE__*/React.createElement("div", {
        "data-qa": "".concat(qa, "#description"),
        className: descriptionClass
      }, description)));
    }
  }]);

  return Trophy;
}(PureComponent);

Trophy.getClassName = function (_ref) {
  var className = _ref.className;
  return {
    root: cx('psw-trophy', 'psw-l-line-left', 'psw-l-anchor', className),
    image: cx('psw-trophy-image', 'psw-l-anchor', 'psw-l-image-m'),
    info: cx('psw-trophy-info', 'psw-p-l-s', 'psw-l-line-enable-truncation'),
    title: cx('psw-truncate-text-1', 'psw-text-medium'),
    description: cx('psw-body-2', 'psw-truncate-text-1', 'psw-c-secondary')
  };
};

Trophy.useClassNames = function (classNames) {
  Trophy.classNames = classNames;
};

Trophy.defaultProps = {
  qa: '',
  className: '',
  title: '',
  description: '',
  image: null,
  trophyType: null
};
Trophy.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * The title for the trophy to display
   */
  title: PropTypes.string,

  /**
   * The image for the trophy to display
   */
  image: PropTypes.string,

  /**
   * The description for the trophy to display
   */
  description: PropTypes.string,

  /**
   * The type of trophy to display
   */
  trophyType: PropTypes.oneOf(['platinum', 'gold', 'silver', 'bronze', 'hidden'])
};
cx = classNamesFor(Trophy);
export default Trophy;